// JG Mesterbyg - Static Data & Configuration

export const CONTACT_INFO = {
  name: "JG Mesterbyg",
  address: "Præstbrovej 173, 7950 Erslev",
  email: "jgmesterbyg@hotmail.com",
  phone: "27294187",
  phoneDisplay: "+45 27 29 41 87",
  cvr: "42219363",
  openingHours: "Mandag - Fredag: 07:00 - 16:00",
};

export const US_POINTS = [
  {
    icon: "fa-award",
    title: "Højeste Kvalitet",
    description: "Vi går aldrig på kompromis med kvaliteten af vores materialer eller håndværk.",
  },
  {
    icon: "fa-handshake",
    title: "Tæt Samarbejde",
    description: "Vi lytter til dine ønsker og rådgiver dig professionelt gennem hele processen.",
  },
  {
    icon: "fa-clock",
    title: "Aftaler Overholdes",
    description: "Vi leverer altid til tiden og til den aftalte pris. Ingen ubehagelige overraskelser.",
  },
  {
    icon: "fa-shield-halved",
    title: "Garantiordning",
    description: "Som professionel dansk håndværker er vores arbejde dækket af garantiordning.",
  },
];

export const TESTIMONIALS = [
  {
    name: "Morten Schmidt",
    city: "Nykøbing Mors",
    rating: 5,
    text: "Fik skiftet tag og efterisoleret loftet af JG Mesterbyg. Super professionelt arbejde, hurtig levering og fantastisk oprydning bagefter. Kan varmt anbefales!",
  },
  {
    name: "Hanne & Peter",
    city: "Thisted",
    rating: 5,
    text: "Vi fik renoveret vores køkken og installeret nye vinduer. Hele processen var præget af god kommunikation og millimeterpræcision. Resultatet er fantastisk.",
  },
  {
    name: "Jesper Thomsen",
    city: "Skive",
    rating: 5,
    text: "Fik opsat solceller på vores tag. JG Mesterbyg rådgav os perfekt om placeringen, og monteringen var utrolig hurtig og pæn. Meget tilfreds!",
  },
];

export const LOGO_URL = "https://assets.auxodev.dk/cdn-cgi/image/width=400,quality=90,format=auto/assets/1c3d2574-7326-4533-ae86-8c8f28cf4f21/logo-jg-mesterbyg-removebg-preview.png";
export const ICON_URL = "https://assets.auxodev.dk/assets/1c3d2574-7326-4533-ae86-8c8f28cf4f21/ikon-jg-mesterbyg.png";
